import type { TStatus } from "@/app/_module/types/filter-types";

export const statusColors: Record<string, string> = {
  // Lowercase (matching database values)
  pending: "bg-primary/10 text-primary",
  confirmed: "bg-green-100 text-green-800",
  completed: "bg-green-100 text-green-800",
  cancelled: "bg-red-100 text-red-800",
  no_show: "bg-orange-100 text-orange-800",
  scheduled: "bg-primary/10 text-primary",
  rescheduled: "bg-yellow-100 text-yellow-800",
  overdue: "bg-red-100 text-red-800",
};
